import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ReferenceVerification, ReferenceVerificationQuestion, ReferenceVerificationData } from 'src/app/models/ApplicantDataResponses/ApplicantDataResponses';
import { ToastrService } from 'ngx-toastr';
import { SearchPackageService } from 'src/app/services/search-package.service';
import { NgForm } from '@angular/forms';
import { ScreeningAdditionalData, ObjectUpdatePayload, ScreeningLight, ApplicantDocument } from 'src/app/models/screeningInvite';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { AuthService } from 'src/app/services/auth.service';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-residence-verification-form',
  templateUrl: './residence-verification-form.component.html',
  styleUrls: ['./residence-verification-form.component.less']
})
export class ResidenceVerificationFormComponent implements OnInit  {

  @ViewChild('form', {}) ngForm: NgForm;
  @Input() ase : ScreeningAdditionalData;
  @Input() resVerModel : ReferenceVerification;
  @Input() screeningToEdit : ScreeningLight;
  // @Input() applicantDocuments: ApplicantDocument[];

  locked : boolean;
  searchProcessing : boolean;
  loaded : boolean = false;
  applicantSuppliedData : ReferenceVerificationData;
  saving : boolean = false;
  
  public get saveButtonText() : string {
    if(this.ase.searchStatus == 1) return 'Start Verification Order'
    else return 'Update Verification Order'
  }
  
  constructor(private toast : ToastrService, private searches : SearchPackageService, public appData : ApplicantDataService, private auth : AuthService,public modalService: NgbModal) { 
    
  }

  cancel(){this.modalService.dismissAll();}
  ngOnInit() {
    this.appData.GetApplicantReferenceData(this.ase.screeningId).subscribe((scc: ReferenceVerificationData)=>{
      this.applicantSuppliedData = scc;
      //console.log(this.applicantSuppliedData)
    })

    this.appData.GetReferenceVerifications(this.ase.searchEntryId).subscribe((vers : ReferenceVerification) => {
      if(vers) {
        this.resVerModel = vers;
      }
      else {
        this.resVerModel = new ReferenceVerification();
      }
      this.resVerModel.orderId = this.ase.searchEntryId;
      //SCRSTP-1119: if the search is pending, i.e. sent to SJV, lock inputs.
      this.locked = this.ase.searchStatus == 2;
      this.setupResVerQuestions();
      this.loaded = true;
    },
    (err : any) => {})
    
  };


  public get model() : ReferenceVerification {
    return this.resVerModel;
  }

  saveRefVer() : void {
    if(this.ngForm.valid && this.model.id > 0) {
      this.searches.updateResVer(this.model).subscribe(res => {
        if(res) {
          this.model.id = res.id;
          this.model.questions.forEach(element => {
            element.responseId = this.model.responseId;
            if(element.response.length > 0)
              this.questionUpdated(element);
          });
          this.toast.success('Successfully updated ResVer information!')
        } else {
          this.toast.error('Failed to update reference verification data!', '', { closeButton: true, disableTimeOut: true })
        }
      },
      (error : any) => {
        this.toast.error('Failed to update reference verification data!', '', { closeButton: true, disableTimeOut: true })
      });
    } else if (this.ngForm.valid) {
      this.saving = true;
      this.searches.saveRefVerification(this.model).subscribe((res : any) => {
        if(res) {
          this.resVerModel.responseId = res.responseId
          this.appData._verifyReference = this.resVerModel;
          this.ase.searchStatus = 2;
          this.toast.success('Successfully saved ResVer information!')
        }
        else {
          this.toast.error('Failed to save reference verification data!', '', { closeButton: true, disableTimeOut: true })
        }
      },
      (error : any) => {
        this.toast.error('Failed to save reference verification data!', '', { closeButton: true, disableTimeOut: true })
      },
      () => this.saving = false)
    } else {
      
    }
  }
  
  questionUpdated(question: ReferenceVerificationQuestion){
    this.searches.saveVerificationQuestion(question).subscribe((rsp : ReferenceVerificationQuestion)=>{
      question.id = rsp.id;
    },
    (error : any) => {
      this.toast.error('Failed to save ', '', { closeButton: true, disableTimeOut: true })
    })
  }

  private setupResVerQuestions() : ReferenceVerificationQuestion[] {
    let questions : ReferenceVerificationQuestion[] = [];
    questions.push(new ReferenceVerificationQuestion(1, "Is the above person a responsible party on the lease? (If no, please explain)", ""));
    questions.push(new ReferenceVerificationQuestion(2, "Are there any problems or complaints on file? (If yes, please explain)", ""));
    questions.push(new ReferenceVerificationQuestion(3, "Are there any pets? (If yes, what type?)", ""));
    questions.push(new ReferenceVerificationQuestion(4, "Is there any property damage? (If yes, please explain)", ""));
    questions.push(new ReferenceVerificationQuestion(5, "Move In Date: ", ""));
    questions.push(new ReferenceVerificationQuestion(6, "Move Out Date: ", ""));
    questions.push(new ReferenceVerificationQuestion(7, "Lease Expiration Date: ", ""));
    questions.push(new ReferenceVerificationQuestion(8, "Proper Notice: ", ""));
    questions.push(new ReferenceVerificationQuestion(9, "Monthly Rental Amount: ", ""));
    questions.push(new ReferenceVerificationQuestion(10, "Late Payments: ", ""));
    questions.push(new ReferenceVerificationQuestion(11, "NSF Checks: ", ""));
    questions.push(new ReferenceVerificationQuestion(12, "Balance Owed: ", ""));
    questions.push(new ReferenceVerificationQuestion(13, "Legal Notice: ", ""));

    if(this.model.questions && this.model.questions.length > 0){
      // then we just need to add any missing questions to the list
      var filtered = questions.filter(q=>{
        return !this.model.questions.find(q2 => q.question == q2.question);
      });
      filtered.forEach(el =>{
        this.model.questions.push(el);
      });

      

    }else{
      this.model.questions = questions;
    }

    return questions;
  }

  //SCRSTP-1119: pulling htis over from the screening-view, so we can relocate the send button to the verification form.
  sendSearchForProcessing() : void {
    if(this.searchProcessing)
    {
      this.toast.warning('Your Previous Search needs a couple more seconds to run');
      return;
    }
    this.searchProcessing = true;
    // since its a manual search if they fire multiple in a row this results in a race condition and multiple order histories getting made. we need to give the ASE time to get out of queued so we can send them.. or just send one ASE and make them both manual
    // For now Im gonna give the Jobs 5 seconds to call the first one sent as not queued anymore
    this.searches.runManualSearch(this.ase.searchEntryId).subscribe((res : boolean) => {

      setTimeout(() =>{
        if(res) {
          this.toast.success('Running search!');
          this.locked = true;
        } else {
          this.toast.error(`${this.ase.searchName} failed to run!`, '', { closeButton: true, disableTimeOut: true });
        }
        this.searchProcessing = false
      } ,5000);
    },
    error => {
      this.toast.error(`${this.ase.searchName} failed to run!`, '', { closeButton: true, disableTimeOut: true });
    });
  }

  resetSearchState(newState : number) : void {
    this.searches.updateSearchStatus(this.ase.searchEntryId, newState).subscribe((res : any) => {
      if(res.success) {
        this.toast.success('Search status updated!');
        this.ase.searchStatus = newState;
        if(newState == 8) this.modalService.dismissAll();
        this.locked = false;
      }
      else {
        this.toast.error('Search failed to update!', '', { disableTimeOut: true, closeButton: true });
      }
    },
    error => {
      this.toast.error('Search failed to update!', '', { disableTimeOut: true, closeButton: true });
    });
  }
 

}
